import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { COLLECTIONS, collectionBanner, filterProducts } from "../lib/store";
import Seo, { breadcrumbSchema } from "../components/Seo";

export default function Collections() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-16">
      <Seo
        title="Jewelry Collections — Gold, Diamond, Silver & More"
        description="Explore nine curated collections at Regal Jewels, Chicago: 22K gold, diamonds, silver, MALO wedding bands, Lladró porcelain, bullion, and jewelry for her, him and kids."
        path="/collections"
        jsonLd={breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Collections", path: "/collections" },
        ])}
      />
      <div className="text-center mb-16">
        <p className="section-eyebrow">Regal Jewels</p>
        <h1 className="section-title">The Collections</h1>
        <p className="text-[#5c5240] mt-5 max-w-xl mx-auto leading-relaxed">
          Nine curated worlds of gold, diamonds, silver and porcelain — each with its own story. Share any collection with a direct link.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {COLLECTIONS.map((c) => {
          const count = filterProducts(c.filter).length;
          return (
            <Link key={c.slug} to={`/collections/${c.slug}`} className="collection-tile group relative overflow-hidden block h-[320px]">
              <img src={collectionBanner(c)} alt={c.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover bg-[#f4efe5]" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1a1713]/70 via-[#1a1713]/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-7">
                <h2 className="font-heading text-3xl text-white">{c.title}</h2>
                <p className="text-xs text-[#e9d9ac]/90 mt-1">{count} pieces</p>
                <span className="inline-flex items-center gap-2 mt-3 text-[10px] tracking-[0.3em] uppercase text-[#e9d9ac] border-b border-[#e9d9ac]/50 pb-1 group-hover:gap-4 transition-all duration-300">
                  Discover <ArrowRight size={12} />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
